<!-- eslint-disable prettier/prettier -->
<template>
  <div class="wrapper">
    <side-bar>
      <template slot="links">
        <sidebar-link to="/profile" name="Профиль" icon="ti-home" />
        <!-- <sidebar-link to="/entityCreation" name="Создание сущности" icon="ti-file" /> -->
        <sidebar-link to="/areasLayout" name="Компетенции" icon="ti-direction-alt" />
        
        <sidebar-link v-show="canSeeUsers" to="/user-rights" name="Пользователи" icon="ti-user" />
        <!-- <sidebar-link v-show="canSeeUsers" to="/appointment" name="Назначение" icon="ti-check-box" />
        <sidebar-link v-show="canSeeUsers" to="/appointment1" name="Назначение1" icon="ti-check-box" /> -->
        <sidebar-link v-show="canSeeUsers" to="/appointment" name="Назначение" icon="ti-check-box" />
        <sidebar-link v-show="canSeeInterviews || interview" to="/interviews" name="Интервью" icon="ti-layout-grid2" />

        <!-- <sidebar-link to="/role-create" name="Создание роли" icon="ti-pencil-alt2" /> -->
        <!-- <sidebar-link to="/history" name="история оценок" icon="ti-write" /> -->
        <!-- <sidebar-link to="/appointment" name="Квалификации" icon="ti-layout-grid2" /> -->
       <!-- <sidebar-link to="/user-creation" name="Новый пользователь" icon="ti-wand" />-->
        <!-- <sidebar-link to="/dashboard" name="Dashboard" icon="ti-panel" /> -->
        <!-- <sidebar-link to="/table-list" name="Table List" icon="ti-view-list-alt"/> -->
        <!-- <sidebar-link to="/typography" name="Typography" icon="ti-text" />-->
        <!-- <sidebar-link to="/icons" name="Иконки" icon="ti-pencil-alt2" />  -->
        <!-- <sidebar-link to="/maps" name="Map" icon="ti-map" />  -->
        <!-- <sidebar-link to="/notifications" name="Уведомления" icon="ti-bell" /> -->
        <!-- <sidebar-link to="/test" name="Тестовая" icon="ti-ruler-pencil" /> -->
        <!-- <sidebar-link to="/authentication" name="Выход"  icon="ti-shift-left-alt" /> -->
        <!-- <sidebar-link @click="document.cookie = 'token=; path=/; expires=-1'" to="/authentication" name="Выход"  icon="ti-shift-left-alt" /> -->

        <!-- Роль
        Тег роли
        Человек или несколько людей
        может ли назначать интервью галка (будет новое право)
        Назначение прав как во вкладке назначений вывести сразу и софт и хард -->

      </template>
      <!-- <mobile-menu>
        <li class="nav-item">
          <a class="nav-link">
            <i class="ti-panel"></i>
            <p>Stats</p>
          </a>
        </li>
        <drop-down
          class="nav-item"
          title="5 Notifications"
          title-classes="nav-link"
          icon="ti-bell"
        >
          <a class="dropdown-item">Notification 1</a>
          <a class="dropdown-item">Notification 2</a>
          <a class="dropdown-item">Notification 3</a>
          <a class="dropdown-item">Notification 4</a>
          <a class="dropdown-item">Another notification</a>
        </drop-down>
        <li class="nav-item">
          <a class="nav-link">
            <i class="ti-settings"></i>
            <p>Settings</p>
          </a>
        </li>
        <li class="divider"></li>
      </mobile-menu> -->
    </side-bar>
    <div class="main-panel">
      <top-navbar></top-navbar>

      <InterviewAssignDialog
        v-if="interviewDialog.visible"
        v-model="interviewDialog.visible"
        :intervieweeId="interviewDialog.intervieweeId"
        :options="interviewDialog.participantsOptions"
        :initialDate="interviewDialog.initialDate"
        @saveInterview="handleInterviewSaved"
      />

      <dashboard-content @click.native="toggleSidebar"> </dashboard-content>

      <content-footer></content-footer>
    </div>
  </div>
</template>
<style lang="scss"></style>
<script>
import Vue from 'vue'
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import DashboardContent from "./Content.vue";
import MobileMenu from "./MobileMenu";
import VueCookies from "vue-cookies-reactive";

import NotificationTemplate from "@/pages/Notifications/NotificationTemplate";
import InterviewAssignDialog from "@/components/InterviewAssignDialog";

import globalMethods from "@/plugins/globalMethods"
import GlobalRequest from "@/plugins/globalRequest"

Vue.use(VueCookies)
export default {
  components: {
    TopNavbar,
    ContentFooter,
    DashboardContent,
    MobileMenu,
    globalMethods,
    InterviewAssignDialog
  },
  data() {
    return {
      roles: [],
      interview: false,
      usersStore: Vue.observable({ users: [] }),
      usersArr: [],

      interviewDialog: {
        visible: false,
        intervieweeId: null,
        participantsOptions: [],
        initialDate: ""
      },
      type: ["", "info", "success", "warning", "danger"],
    }
  },

  provide() {
    return {
      usersStore: this.usersStore,  // передаём во все дочерние компоненты
      setUsersStore: (users) => { this.usersStore.users = Array.isArray(users) ? users : [] },

      openInterview: this.openInterview,
      closeInterview: this.closeInterview
    };
  },

  computed: {
    // Видим вкладку пользователей, если они есть
    canSeeUsers() {
      return this.usersArr && this.usersArr.length > 0;
    },

    canSeeInterviews() {
      return globalMethods.canSeeInterviews(this.roles);
    }
  },

  async mounted() {
    this.roles = globalMethods.getRoles();

    const userID = localStorage.getItem("current_user");
    if (!userID) return;

    const resUser = await GlobalRequest.request("/user/" + userID, "GET");
    if (resUser && resUser.data) {
      console.log(resUser)

      const role = resUser.data.roles;
      localStorage.setItem('role', JSON.stringify(role));
    }

    // Есть ли подчиненные или текущий пользователь админ
    const isAdmin = globalMethods.isAdmin(this.roles);

    if (isAdmin) {
      const res = await GlobalRequest.request("/user/list", "GET");
      if(res && res.data) {
        this.usersArr = res.data;
      }
    } else {
      if (resUser && resUser.data) {
        const subordinates = Array.isArray(resUser.data.subordinates)
          ? resUser.data.subordinates
          : [];

        const padawans = Array.isArray(resUser.data.padawans)
          ? resUser.data.padawans
          : [];

        this.usersArr = [...subordinates, ...padawans];

        // В список добавить себя
        if(this.usersArr && this.usersArr.length > 0 && resUser && resUser.data) {
          this.usersArr.push(resUser.data)
        }
        
      }
    }

    if(this.usersArr.length < 1) {
      localStorage.removeItem("selected_user");
    }

    // console.log(this.usersArr)
    this.usersStore.users =  this.usersArr;

    // this.users = [];

    // Интервью
    const result = await GlobalRequest.request(`/interviews/user/${userID}`, "GET");

    let allInterviews = [];
    if(result && result.data) {
      Object.values(result.data).forEach(list => {
        if (Array.isArray(list)) {
          allInterviews = allInterviews.concat(list);
        }
      });
    }

    this.interview = allInterviews.some(inter => inter.status !== "accepted");

    // const resNotifications = await GlobalRequest.request("/notifications", "GET");
    // if(resNotifications && resNotifications.data) {
    //   console.log(resNotifications)

    //   let body = {
    //     id: resNotifications.data[0].id
    //   }
    //   const resReadNotification = await GlobalRequest.request("/notifications/read", "POST", body);
    //   if(resReadNotification) {
    //     console.log(resReadNotification)
    //   }

    // }

    
  },

  methods: {
    toggleSidebar() {
      if (this.$sidebar.showSidebar) {
        this.$sidebar.displaySidebar(false);
      }
    },

    getDate() {
      const d = new Date();
      const day = ("0" + d.getDate()).slice(-2);
      const month = ("0" + (d.getMonth() + 1)).slice(-2);
      const year = d.getFullYear();
      const hours = ("0" + d.getHours()).slice(-2);
      const minutes = ("0" + d.getMinutes()).slice(-2);
      return `${year}-${month}-${day}T${hours}:${minutes}`;
    },

    openInterview(intervieweeId) {
      if (!intervieweeId) return;

      const currentUserId = localStorage.getItem("current_user");

      // Берём людей из usersStore
      const all = Array.isArray(this.usersStore.users) ? this.usersStore.users : [];

      const participants = all
        .filter(u =>
          u &&
          String(u.id) !== String(currentUserId) &&
          String(u.id) !== String(intervieweeId)
        )
        .map(u => ({
          id: u.id,
          title: `${u.name} ${u.lastName || ""}`.trim(),
          img: u.avatar || "noFoto"
        }));

      this.interviewDialog.intervieweeId = intervieweeId;
      this.interviewDialog.participantsOptions = participants;
      this.interviewDialog.initialDate = this.getDate();
      this.interviewDialog.visible = true;
    },

    closeInterview() {
      this.interviewDialog.visible = false;
    },

    handleInterviewSaved(result) {
      if (result && result.success) {
        this.interviewDialog.visible = false;
        this.notifyVue('bottom', 'right', 2, "Интервью было успешно запланировано");
      } else {
        this.notifyVue('bottom', 'right', 4, "Произошла ошибка при планировании интервью");
      }
    },

    notifyVue(verticalAlign, horizontalAlign, color, text) {
      this.$notify({
        component: NotificationTemplate,
        horizontalAlign: horizontalAlign,
        verticalAlign: verticalAlign,
        type: this.type[color],
        message: text,
      });
    },

  },
};
</script>
